<template>
    <div class="content md">
        <system-admin type="rec"></system-admin>
    </div>
</template>

<script>
    import SystemAdmin from "../../layouts/SystemAdmin";
    export default {
        name: "RecAdmin",
        components: {
            SystemAdmin
        }
    }
</script>

<style scoped>

</style>
